import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Download, Mail, Heart, Sparkles } from "lucide-react";

const GUIDE_PDF_URL =
  "https://customer-assets.emergentagent.com/job_domain-landing-2/artifacts/hlzmlp9e_3_FUNDAMENTOS_ESCENCIALES_DEL_LADY_STYLING_CUBANO.pdf";

export default function GraciasPage() {
  const location = useLocation();
  const name = location.state?.name || "hermosa";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: "100vh", padding: "80px 24px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="gracias-card fade visible">
        <div className="gracias-badge">
          <Sparkles size={22} strokeWidth={1.8} />
        </div>

        <span className="eyebrow" style={{ marginBottom: 16 }}>Bienvenida · Tu lugar está listo</span>
        <h1 className="gracias-h1">
          Gracias, <em>{name}</em>.
        </h1>
        <p className="gracias-sub">
          Tu guía ya está en camino. Te he enviado un correo a tu email con el enlace de descarga
          y unas palabras desde el corazón.
        </p>

        <a href={GUIDE_PDF_URL} target="_blank" rel="noreferrer" className="btn wide gracias-cta">
          <Download size={18} strokeWidth={2} />
          Descargar la Guía Ahora
        </a>

        <div className="gracias-divider"></div>

        <div className="gracias-steps">
          <div className="gracias-step">
            <div className="gracias-step-icon"><Mail size={18} strokeWidth={1.8} /></div>
            <div>
              <h4>Revisa tu correo</h4>
              <p>Acabas de recibir un email de <strong>contacto@yarimarodriguez.com</strong> con tu guía gratuita. Si no la ves, revisa la carpeta de spam o promociones.</p>
            </div>
          </div>
          <div className="gracias-step">
            <div className="gracias-step-icon"><Heart size={18} strokeWidth={1.8} /></div>
            <div>
              <h4>Los próximos días</h4>
              <p>Durante esta semana te enviaré tres cartas personales con reflexiones que te acompañarán a sentirte más conectada con tu cuerpo cada vez que bailas.</p>
            </div>
          </div>
          <div className="gracias-step">
            <div className="gracias-step-icon"><Sparkles size={18} strokeWidth={1.8} /></div>
            <div>
              <h4>Empieza cuando quieras</h4>
              <p>La guía es tuya, a tu ritmo. Léela con calma, deja que las palabras lleguen y empieza por <em>La Base</em>.</p>
            </div>
          </div>
        </div>

        <p className="gracias-quote">
          "No se trata de convertirte en otra persona.<br />
          Se trata de sacar a la luz esa versión de ti que ya estaba ahí."
        </p>
        <p className="gracias-signature">— Yarima</p>

        <Link to="/" className="gracias-back">← Volver al inicio</Link>
      </div>
    </div>
  );
}
